import authenticationFunctions from "./methods/authentication.functions";
import dataFetchFunctions from "./methods/data-fetch.functions";
import eventHandlingFunctions from "./methods/event-handling.functions";
import exportFunctions from "./methods/export.functions";
import gridRenderFunctions from "./methods/grid-render.functions";
import utilsFunctions from "./methods/utils.functions";

export default {
  ...exportFunctions,
  ...authenticationFunctions,
  ...dataFetchFunctions,
  ...gridRenderFunctions,
  ...utilsFunctions,
  ...eventHandlingFunctions,
};
